import {
  transformHistoryDataToDataSource,
  transformHistoryDataToDataSourceAthletics,
  transformHistoryDataToDataSourceLaunch,
  transformHistoryDataToDataSourceSimulation,
  transformHistoryDataToDataSourceTonal,
  transformHistoryDataToUserHistory,
} from "../helpers";
import {
  columnsUserHistoryArray,
  columnsUserHistoryArrayAthletics,
  columnsUserHistoryArrayBaseball,
} from "./constants";

export function getDatatableWidth() {
  const innerWidth = window?.innerWidth;

  if (innerWidth > 1800) return 1500;

  return innerWidth - 400;
}

export function getDataSourceForHistory(
  pathname: any,
  historyData: any,
  activeSportType: any,
) {
  let dataSource;

  switch (pathname) {
    case "/m2c-golf-history":
      dataSource = transformHistoryDataToDataSource(historyData);
      break;
    case "/pg-history":
      dataSource = transformHistoryDataToDataSource(historyData);
      break;
    case "/m2c-launch-history":
      dataSource = transformHistoryDataToDataSourceLaunch(historyData);
      break;
    case "/m2c-athletics-history":
      dataSource = transformHistoryDataToDataSourceAthletics(historyData);
      break;
    case "/simulation-history":
      dataSource = transformHistoryDataToDataSourceSimulation(historyData);
      break;
    case "/tonal-history":
      dataSource = transformHistoryDataToDataSourceTonal(historyData);
      break;
    case "/user-history":
      dataSource = transformHistoryDataToUserHistory(
        historyData,
        activeSportType,
      );
      break;
    default:
      break;
  }

  return dataSource;
}

export const getTimeIntervalInMillis = (timeInterval: string): number => {
  switch (timeInterval) {
    case "1 hr":
      return 1 * 60 * 60 * 1000; // 1 hour in milliseconds
    case "4 hrs":
      return 4 * 60 * 60 * 1000; // 4 hours in milliseconds
    case "8 hrs":
      return 8 * 60 * 60 * 1000; // 8 hours in milliseconds
    case "12 hrs":
      return 12 * 60 * 60 * 1000; // 12 hours in milliseconds
    case "1 day":
      return 24 * 60 * 60 * 1000; // 1 day in milliseconds
    case "3 days":
      return 3 * 24 * 60 * 60 * 1000; // 3 days in milliseconds
    case "1 week":
      return 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
    case "All":
      return Infinity; // Return infinity for "All" option
    default:
      return 0; // Return 0 for unknown time intervals
  }
};

export function getColumnBasedOnSport(sportType: string) {
  switch (sportType) {
    case "golf":
      return columnsUserHistoryArray;
    case "baseball":
      return columnsUserHistoryArrayBaseball;
    case "athletics":
      return columnsUserHistoryArrayAthletics;

    default:
      return columnsUserHistoryArray;
  }
}
